// extracted by mini-css-extract-plugin
module.exports = {"how_works":"HowWorks_how_works__cg5Xb"};